import { defineComponent as p, useCssModule as m, inject as h, computed as i, createBlock as f, openBlock as g, unref as a, normalizeClass as b } from "vue";
import k from "lodash-es/uniqueId";
import { I as w } from "./index-D6bxWkZ1.js";
import { _ } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const v = [
  "action-dots",
  "activity",
  "alert-bell",
  "archive",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "badge-discount",
  "badge-seller-elite",
  "badge-seller-power",
  "badge-seller-verified",
  "book-customer",
  "building-office",
  "bulk-add",
  "calendar-reschedule",
  "calendar",
  "camera",
  "caret-down",
  "caret-up",
  "change-log",
  "check",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "circle-check",
  "circle-close",
  "circle-dollar",
  "circle-empty",
  "circle-info",
  "circle-partial",
  "circle-percent",
  "circle-question-mark",
  "circle-slash",
  "circle-status",
  "circle-warning",
  "clipboard-checkmark",
  "clipboard-inventory",
  "close",
  "combine",
  "compass",
  "contact",
  "contract",
  "copy",
  "credit-card",
  "credit-profile",
  "dashboard",
  "document-accept",
  "document-invoice",
  "document-recieved",
  "document-sent",
  "document-view",
  "document",
  "dolly",
  "download",
  "edit",
  "ellipsis",
  "envelope-open",
  "envelope",
  "equals",
  "export",
  "figma",
  "file-csv",
  "file",
  "filter-funnel",
  "filter-line",
  "flag",
  "folder",
  "folder-bar-graph",
  "folder-orders",
  "font-bold",
  "font-clear-format",
  "font-italic",
  "font-underline",
  "gear",
  "github",
  "globe",
  "graph-bar-chart",
  "graph-line-chart",
  "graph-pie-chart",
  "hazard",
  "hazard-outline",
  "headset-agent",
  "headset-mic",
  "heart-filled",
  "heart-outline",
  "help-question-mark",
  "hide",
  "history",
  "home",
  "image",
  "import",
  "keyboard-return",
  "tier-1",
  "tier-2",
  "tier-3",
  "license-approved",
  "license-certificate",
  "lightbulb",
  "link-add",
  "link-unlink",
  "link",
  "list-bulleted",
  "list-items",
  "list-numbered",
  "loading-big",
  "loading-empty",
  "loading-small",
  "location",
  "lock-unlock",
  "lock",
  "logo-facebook",
  "logo-instagram",
  "logo-linkedin",
  "logo-ll",
  "logo-metrc",
  "logo-plaid",
  "logo-x",
  "logo-youtube",
  "logout",
  "medical",
  "megaphone-sound",
  "megaphone",
  "menu",
  "message-dispute",
  "message-reply",
  "message",
  "minus",
  "mj-leaf",
  "money",
  "note-add",
  "note",
  "open-in-new",
  "paperclip",
  "paper-plane",
  "performance",
  "phone",
  "plus",
  "preview",
  "print",
  "product-menu-manage",
  "product-menu-search",
  "product-menu",
  "queue-add",
  "queue",
  "recent",
  "refresh",
  "register",
  "reply",
  "report-download",
  "sample",
  "save",
  "scale-law",
  "scale-weight",
  "search",
  "seed-cycle",
  "share",
  "shop-bag-browse",
  "shop-bag-reorder",
  "shop-bag",
  "shop-basket",
  "shop-cart-add",
  "shop-cart",
  "show",
  "sign-dollar",
  "sign-percent",
  "sort",
  "split",
  "star-filled",
  "star-outline",
  "start",
  "storefront",
  "submit",
  "swap-horizontal",
  "swap-vertical",
  "tag-star",
  "tag",
  "test-results",
  "ticket-star",
  "ticket",
  "tool-dropper",
  "tool-wrench",
  "transfer",
  "trashcan",
  "truck",
  "upload",
  "user-add",
  "user-admin",
  "user-check",
  "user-group",
  "user",
  "view-card",
  "view-detailed",
  "view-list",
  "warehouse",
  "working"
];
var y = /* @__PURE__ */ ((r) => (r.Standard = "standard", r.Dense = "dense", r.Small = "small", r.Large = "large", r))(y || {});
const x = /* @__PURE__ */ p({
  name: "ll-icon",
  __name: "Icon",
  props: {
    id: { default: () => k("ll-icon-") },
    name: {},
    title: { default: "" },
    size: { default: "standard" },
    dense: { type: Boolean },
    small: { type: Boolean },
    staticPath: { default: "" }
  },
  setup(r) {
    const e = r, o = m(), s = h("stashOptions", {
      staticPath: "/static"
    }), n = i(() => v.includes(e.name) ? e.name : "mj-leaf"), d = i(() => e.staticPath || (s == null ? void 0 : s.staticPath)), u = (t) => {
      if (!t)
        return t;
      const l = document.createElement("use");
      l.setAttribute("href", `#${n.value}`);
      const c = t.querySelector(`#${n.value}`);
      return c ? (t.replaceChildren(c, l), t) : (t.insertBefore(l, t.firstChild), t);
    };
    return (t, l) => (g(), f(a(w), {
      id: e.id,
      role: "presentation",
      "aria-labelledby": e.id,
      class: b(["stash-icon", [
        a(o).icon,
        `icon--${e.name}`,
        {
          [a(o).standard]: e.size === "standard",
          [a(o).dense]: e.size === "dense" || e.dense,
          [a(o).small]: e.size === "small" || e.small,
          [a(o).large]: e.size === "large"
        }
      ]]),
      "data-test": "stash-icon",
      src: `${d.value}/spritesheet.svg`,
      title: e.title,
      "transform-source": u
    }, null, 8, ["id", "aria-labelledby", "class", "src", "title"]));
  }
}), q = "_icon_1x7lf_2", z = "_standard_1x7lf_8", B = "_dense_1x7lf_15", C = "_small_1x7lf_22", P = "_large_1x7lf_29", $ = {
  icon: q,
  standard: z,
  dense: B,
  small: C,
  large: P
}, N = {
  $style: $
}, A = /* @__PURE__ */ _(x, [["__cssModules", N]]);
export {
  y as IconSizes,
  A as default,
  v as iconNames
};
//# sourceMappingURL=Icon.js.map
